import { keyframes } from "styled-components";

const Marquee = keyframes`
  0% {
    transform: translateX(-110%);
    opacity: 1;

  }

  100% {
    transform: translateX(100vw);    
    opacity: 1;
  }
`;

export default Marquee;
